<div class="p-4">
  <div class="d-flex align-items-start justify-content-between mb-3">
    <div class="card-sub-heading title_size20"><img alt="note icon" src="assets/images/random_assets/note.png" style="max-width: 40px;" class="me-1"/> Note</div>
    <button mat-icon-button (click)="this.dialogRef.close()" type="button">
      <img alt="close icon" src="assets/images/icons/grey_cross_icon.png" />
    </button>
  </div>
  
  <div
    class=""
    *ngIf="!warning"
  >
    <form [formGroup]="form" (ngSubmit)="formSubmit()">
      
  
      <textarea
        class="form-control height"
        rows="3"
        placeholder="Write your note..."
        formControlName="Notes"
      ></textarea>
      <app-error-message [formName]="form" [fieldName]="'Notes'" [type]="'group'">
      </app-error-message>
      <div class="row mt-4">
        <div class="col-md-12 d-flex align-items-center justify-content-end">
          <button
            class="custom-btn"
            type="button"
            (click)="this.dialogRef.close()"
          >
            Cancel
          </button>
          <button class="custom-btn" [disabled]="isLoading" type="submit">
            Save
            <span class="whiteLoader" *ngIf="isLoading"></span>
          </button>
        </div>
      </div>
    </form>
  </div>
  
  <div
    class="d-flex flex-column align-items-center justify-content-center"
    *ngIf="warning"
  >
    <img alt="warning icon" src="assets/images/random_assets/warning.png" />
    <div class="card-sub-heading my-3">Warning</div>
    <div>Do you wants to send notification to user about changing state?</div>
    <div class="row mt-4">
      <div class="col-md-12 d-flex align-items-center justify-content-center">
        <button class="custom-btn" disabled>No! not now</button>
        <button class="custom-btn">Yes! notify them</button>
      </div>
    </div>
  </div>
  
</div>